import { render, staticRenderFns } from "./TeacherHistoryHeader.vue?vue&type=template&id=2644816a&scoped=true&lang=pug&"
import script from "./TeacherHistoryHeader.vue?vue&type=script&lang=ts&"
export * from "./TeacherHistoryHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherHistoryHeader.vue?vue&type=style&index=0&id=2644816a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2644816a",
  null
  
)

export default component.exports